import React, { Component } from "react";
import YouTube from "react-youtube";
import ReactPlayer from "react-player";

export default class Video extends Component {
  render() {
    if (this.props.contentType === "youtube") {
      const opts = {
        width: "70%",
        playerVars: {
          autoplay: 1,
        },
      };
      return (
        <div className="text-center">
          <h1>{this.props.heading}</h1>
          <h3>{this.props.description}</h3>
          <YouTube videoId={this.props.ID} opts={opts} />
        </div>
      );
    } else if (this.props.contentType === "video") {
      return (
        <div>
          <h1>{this.props.heading}</h1>
          <h3>{this.props.description}</h3>
          <ReactPlayer
            url={`${this.props.ID}.mp4`}
            playing
            controls
            width="100%"
          />
        </div>
      );
    }
  }
}
